import React from 'react'

import { Logo, Modal, Register } from 'components'

import { useInformation } from './useInformation'

import styles from './Information.module.scss'
import CardContentContainer from 'components/CardContentContainer/CardContentContainer'

const Information = () => {
  const { modalOpen, handleRegisterOptionClick, handleOpenModal, handleCloseModal } =
    useInformation()

  return (
    <div className={styles.container}>
      <Logo />

      <CardContentContainer>
        <div className={styles.register}>
          <Register
            handleRegisterOptionClick={handleRegisterOptionClick}
            handleOpenModal={handleOpenModal}
          />
        </div>
      </CardContentContainer>
      {modalOpen && <Modal onClose={handleCloseModal} />}
    </div>
  )
}

export default Information
